export const getCookieName = (): string => {
  const origin = window.location.origin
  const pathname = window.location.pathname

  if (origin === 'http://localhost:3000') {
    return 'XK_AUTH_TOKEN_LOCAL'
  } else if (origin === 'https://ai-portal-qualif.sightcall.com') {
    return 'XK_AUTH_TOKEN_QUALIF'
  } else if (origin === 'https://ai-portal-prr.sightcall.com') {
    return 'XK_AUTH_TOKEN_PPR_EU'
  } else if (origin === 'https://ai-portal-usprr.sightcall.com') {
    return 'XK_AUTH_TOKEN_PPR_US'
  } else if (origin === 'https://ai-portal.sightcall.com') {
    return 'XK_AUTH_TOKEN_PROD_EU'
  } else if (origin === 'https://ai-portal-us.sightcall.com') {
    return 'XK_AUTH_TOKEN_PROD_US'
  } else {
    return 'XK_AUTH_TOKEN_LOCAL'
  }
}

export const deleteCookie = (name: string) => {
  document.cookie = `${name}=; Max-Age=-99999999; path=/`
}

export const setCookie = (name: string, value: string, days = 0.5) => {
  const date = new Date()
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
  const expires = `; expires=${date.toUTCString()}`
  document.cookie = `${name}=${value}${expires}; path=/; SameSite=Strict`
}

export const getCookie = (name: string): string | null => {
  const nameEQ = `${name}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim()
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}
